// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.S5UazNYxo8KHgL {
  box-sizing: border-box;
  width: 32px;
  height: 24px;
  margin-top: 4px;
  padding: 3px 7px;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 12px;
  line-height: 1;
  cursor: pointer;
}
.S5UazNYxo8KHgL:hover {
  border: 1px solid var(--ds-border, #091e4224);
}
.S5UazNYxo8KHgL .yd9VloF8iQQANV {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  background-size: contain;
}
.S5UazNYxo8KHgL .yd9VloF8iQQANV .vvUjV8xlvj93Tv {
  width: 100%;
  height: 100%;
}
.S5UazNYxo8KHgL .yd9VloF8iQQANV .vvUjV8xlvj93Tv path {
  fill: var(--ds-icon-subtle, #626f86);
}
.S5UazNYxo8KHgL.wXECjFwoueJ7ls {
  border-color: var(--ds-border-brand, #0c66e4);
  background-color: var(--ds-background-brand-bold, #0c66e4);
}
.S5UazNYxo8KHgL.wXECjFwoueJ7ls .yd9VloF8iQQANV path {
  fill: var(--ds-icon-inverse, #ffffff);
}
.S5UazNYxo8KHgL.F1LiiZ0E9OvYhO {
  cursor: default;
  pointer-events: none;
}
.S5UazNYxo8KHgL.F1LiiZ0E9OvYhO .yd9VloF8iQQANV path {
  fill: var(--ds-icon-disabled, #091e424f);
}
.S5UazNYxo8KHgL.WwsQwPoeLqGrwP {
  display: inline-block;
  width: 13px;
  height: 13px;
  margin: 0 12px 0 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  background-color: transparent;
  vertical-align: text-bottom;
}
.S5UazNYxo8KHgL.WwsQwPoeLqGrwP:hover {
  background-color: transparent;
}
.S5UazNYxo8KHgL.WwsQwPoeLqGrwP .yd9VloF8iQQANV {
  width: 12px;
  height: 12px;
}
.S5UazNYxo8KHgL.WwsQwPoeLqGrwP:hover .yd9VloF8iQQANV path {
  fill: var(--ds-icon-accent-gray, #758195);
}
.S5UazNYxo8KHgL.WwsQwPoeLqGrwP.wXECjFwoueJ7ls .yd9VloF8iQQANV path {
  fill: var(--ds-icon-brand, #0c66e4);
}
.S5UazNYxo8KHgL.WwsQwPoeLqGrwP.F1LiiZ0E9OvYhO .yd9VloF8iQQANV {
  pointer-events: none;
}
.S5UazNYxo8KHgL.WwsQwPoeLqGrwP.swMV7vQHpOa82F {
  display: flex;
  align-items: center;
  width: 24px;
  margin-top: 0;
  margin-right: 0;
}
.S5UazNYxo8KHgL.WwsQwPoeLqGrwP.swMV7vQHpOa82F::after {
  content: '•';
  margin-left: 6px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
}
.S5UazNYxo8KHgL.QpsHo6AmajHQKq {
  width: 32px;
  height: 24px;
  margin-bottom: 4px;
  padding: 5px 9px;
}
.S5UazNYxo8KHgL.QpsHo6AmajHQKq .yd9VloF8iQQANV {
  width: 12px;
  height: 12px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reactionAddButton": `S5UazNYxo8KHgL`,
	"icon": `yd9VloF8iQQANV`,
	"iconSvg": `vvUjV8xlvj93Tv`,
	"active": `wXECjFwoueJ7ls`,
	"disabled": `F1LiiZ0E9OvYhO`,
	"small": `WwsQwPoeLqGrwP`,
	"smallCardBack": `swMV7vQHpOa82F`,
	"cardBack": `QpsHo6AmajHQKq`
};
export default ___CSS_LOADER_EXPORT___;
